import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  transparent?: boolean;
}

export default function Navbar({ transparent = false }: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, []);

  const showWhiteBg = !transparent || isScrolled;

  const navItems = [
    { path: '/', label: '首頁' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      showWhiteBg ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-transparent'
    }`}>
      <div className="px-8 py-4 flex items-center justify-between">
        <Link
          to="/"
          className={`flex items-center gap-3 transition-all duration-500 cursor-pointer ${isLoaded ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}
        >
          <div className="w-9 h-9 flex items-center justify-center flex-shrink-0">
            <img
              src="https://static.readdy.ai/image/21854ded7812c3e1f6e0237d0c8099eb/b16dfe45d3df984f479dd6ea789b5412.png"
              alt="恩誠國際 Logo"
              className="w-9 h-9 object-contain"
            />
          </div>
          <div>
            <div className={`font-bold text-base leading-tight transition-colors duration-500 ${showWhiteBg ? 'text-gray-900' : 'text-white'}`}>
              恩誠國際
            </div>
            <div className={`text-xs leading-tight transition-colors duration-500 ${showWhiteBg ? 'text-gray-400' : 'text-white/70'}`}>
              En-Cheng International
            </div>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navItems.map((item, index) => (
            <Link
              key={item.path}
              to={item.path}
              className={`transition-all duration-500 cursor-pointer font-medium text-sm hover:scale-105 ${
                location.pathname === item.path
                  ? 'text-teal-600'
                  : showWhiteBg
                    ? 'text-gray-600 hover:text-teal-600'
                    : 'text-white/90 hover:text-white'
              } ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}
              style={{ transitionDelay: `${(index + 1) * 80}ms` }}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${showWhiteBg ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'}`}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-gray-100 px-6 py-4 flex flex-col gap-3">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => setMobileOpen(false)}
              className={`py-2 font-medium text-sm cursor-pointer transition-colors ${
                location.pathname === item.path ? 'text-teal-600' : 'text-gray-700 hover:text-teal-600'
              }`}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/contact"
            onClick={() => setMobileOpen(false)}
            className="mt-2 px-5 py-2.5 bg-gradient-to-r from-teal-500 to-emerald-500 text-white rounded-lg font-medium text-sm text-center whitespace-nowrap cursor-pointer"
          >
            免費諮詢
          </Link>
        </div>
      )}
    </nav>
  );
}
